export type AssociationFlow = 'smb' | 'mspChild' | 'mspParent' | 'unknown';

export type ResolvedAssociationFlow = Exclude<AssociationFlow, 'unknown'>;

export const getAssociationFlow = (
  customerType: string | undefined | null
): AssociationFlow => {
  if (customerType === 'Child') return 'mspChild';
  if (customerType === 'Partner') return 'mspParent';
  if (!customerType || customerType === 'Direct' || customerType === 'NA')
    return 'smb';
  return 'unknown';
};
